import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { ReportCardNetworthComponent } from '@app/shared/component/my-report-container/report-card-networth/report-card-networth.component';
import { DocumentService, ReminderUpdate } from '@app/shared/services';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as vaultSelector from '../../../../../root-store/vault-store/vault.selector';
import { AddValueBalancePopupComponent } from '../add-value-balance-popup/add-value-balance-popup.component';
import { AttributesDialogComponent } from '../insurance-attributes/attributes-dialog/attributes-dialog.component';
import { BalanceSubjectService } from '@app/shared/component/current-balance-card/balance-attribute-subject-behavior';
import { CurrentBalanceCardComponent } from '@app/shared/component/current-balance-card/current-balance-card.component';
import { FetchAttributeDataSubject } from './attribute-subject.service';
import { take } from 'rxjs/operators';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

enum EAttributesTypes {
  financialAttribute = 'financial-attribute',
  insuranceAttribute = 'insurance-attribute',
}
@AutoUnsubscribe()
@Component({
  selector: 'add-finacial-attribute',
  templateUrl: './add-finacial-attribute.component.html',
  styleUrls: ['./add-finacial-attribute.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddFinancialAttributeComponent implements OnInit, OnDestroy {
  @ViewChild('childTransactionAttribute') addFinancialAttributeComponent: AddFinancialAttributeComponent;
  @ViewChild('reportCard') reportCard: ReportCardNetworthComponent;
  @ViewChild(CurrentBalanceCardComponent) currentBalanceCardComponent: CurrentBalanceCardComponent;

  @Input() mode;
  @Input() name;
  @Input() data;
  @Input() currentuserId;
  @Input() currentFormId;
  @Input() userId;
  @Input() isRemoveEditSaveSharing;
  @Input() fId;
  @Input() connected_to_institution;
  @Input() currentVaultUserId;
  @Input() countList;
  @Input() formName = '';
  @Input() templateId = null;
  @Input() selectedFileList = [];
  @Input() isFromTemplate = false;
  @Input() transaction_register_disabled;
  @Output() someEvent = new EventEmitter<string>();
  @Output() passEvent = new EventEmitter<any>();
  @Output() setupItemEmitter = new EventEmitter<any>();
  @Output() updateCountListEventEmittted = new EventEmitter<any>();
  @Output() updateApiEmitter = new EventEmitter<any>();
  attribute_sub_class;
  attribute_class;
  has_transaction = false;
  currentValue;
  isLoading = true;
  title;
  @Input() has_death_benefit = 0;
  currentDate;
  screenWidth: number;
  subscription = new Subscription();

  allAttributeData = undefined;
  attributesList = signal([]);
  hasDistribution = signal(false);
  isLoadingBalance = signal(true);
  hasCapitalCommitment = signal(false);

  distribution = {
    key: 'Add Distribution',
    value: {
      title: 'Add Distribution',
      inputs: [
        {
          title: 'Distribution Amount (In USD)',
          key: 'value',
          type: 'Dollar Input',
        },
        {
          title: 'Distribution Type',
          key: 'distribution_type',
          type: ['Return of Capital', 'Return on Capital', 'Other'],
        },
        {
          title: 'Date',
          key: 'as_of',
          type: 'Date Selection',
          default: 'today',
        },
      ],
      History: 'Register 2',
      vault_form_code: 'has_distribution',
      Register_keys: ['distribution_type', 'value'],
    },
  };
  capitalCommitment = {
    key: 'Add Contribution',
    value: {
      title: 'Add Contribution',
      inputs: [
        {
          title: 'Contribution Amount (In USD)',
          key: 'value',
          type: 'Dollar Input',
        },
        {
          title: 'Date',
          key: 'as_of',
          type: 'Date Selection',
          default: 'today',
        },
        {
          title: 'Reporting',
          key: 'reporting',
          type: 'Assets & Liabilities',
          default: 'Not Editable',
        },
      ],
      History: 'Register 2',
      vault_form_code: 'has_capital_commitment',
      Register_keys: ['value'],
    },
  };
  highPriorityAttributes = [
    'has_est_value',
    'has_current_balance',
    'has_current_value',
    'has_life_insurance',
    'has_stk_optns',
    'has_stk_reg',
    'has_stock_warrants_register',
    'has_financial_commitment',
    'has_real_estate_value_estimate',
    'has_cry_reg',
    'has_automobile_value_estimate',
    'has_foreign_currency_register',
    'has_precious_metal_register',
    'has_public_equity',
    'has_capital_commitment',
    'has_airline_miles',
    'has_rewards_points',
  ];
  constructor(
    private documentService: DocumentService,
    private store: Store,
    private vaultService: VaultStoreEffects,
    private reminderUpdate: ReminderUpdate,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private router: Router,
    private balanceDataBehaviorSubject: BalanceSubjectService,
    private attributeSubject: FetchAttributeDataSubject
  ) {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.getList();
    this.subscription.add(
      this.attributeSubject.fetchAttributeData.subscribe((res) => {
        if (res) {
          this.allAttributeData = undefined;
          this.attributesList.set([]);
          this.financialAttributes = undefined;
          this.hasCalledApi ? this.getList() : '';
        }
      })
    );
  }

  addDeathBalance(attributeType) {
    const dialogRef = this.dialog.open(AddValueBalancePopupComponent, {
      height: '100%',
      data: {
        registerType: 'balance',
        currentFormId: this.currentFormId,
        currentuserId: this.currentuserId,
        title: this.title,
        attributeType: attributeType,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res.isSuccess) {
          this.subscription.add(this.reminderUpdate.sendMessage('true'));
          this.getList();
          this.reportCard.generateValueHistory();
        }
      })
    );
  }

  getUpdateList(id, fId) {
    this.currentFormId = id;
    this.fId = fId;
    this.getList();
    this.addFinancialAttributeComponent.getUpdateList(this.currentFormId, this.data.form_id);
  }
  financialAttributes;
  allAttributes;
  income_expense_class = '';
  income_expense_sub_class = '';
  hasCalledApi = true;
  api_source = '';
  // hasCalledApi edit this
  getList() {
    this.hasCalledApi = false;
    this.subscription.add(
      this.vaultService.vaultObject.subscribe(
        (state) => {
          let res = state.forms;
          if (res.length && res.findIndex((x) => x.id == this.fId) != -1) {
            this.attribute_class = res[res.findIndex((x) => x.id == this.fId)].attribute_class;
            this.attribute_sub_class = res[res.findIndex((x) => x.id == this.fId)].attribute_sub_class;
            this.income_expense_sub_class = res[res.findIndex((x) => x.id == this.fId)].income_expense_sub_class;
            this.income_expense_class = res[res.findIndex((x) => x.id == this.fId)].income_expense_class;
          }
        },
        (error) => {
          this.toastr.error(error.error.response.message);
        }
      )
    );

    if (this.currentFormId) {
      let needToPassCurrntUserId = this.userId;
      if (this.router.url.includes('collaboration') && !this.router.url.includes('admin=true')) {
        needToPassCurrntUserId = this.currentuserId;
      }

      this.subscription.add(
        this.store
          .select(vaultSelector.getCurrentFormsById(this.fId))
          .pipe(take(1))
          .subscribe((response) => {
            if (!!response?.financial_attributes?.trim()) {
              this.financialAttributes = response?.financial_attributes.split(',');
              this.allAttributes = response?.financial_attributes.split(',');
              this.has_transaction = !!this.financialAttributes.includes('has_transactions');
              // use.. response.api_source
              this.api_source = response?.api_source;

              this.getDataForAttributes();
              this.passEvent.emit({
                title: this.title,
                currentDate: this.currentDate,
              });

              this.cd.detectChanges();
            }
            if (!!response?.attributes_no_setup) {
              const hasDistribution = response?.attributes_no_setup?.split(',')?.includes('has_distributions');
              this.hasDistribution.set(hasDistribution);

              const hasCapitalCommitment = response?.attributes_no_setup?.split(',')?.includes('has_capital_commitment');
              this.hasCapitalCommitment.set(hasCapitalCommitment);
            }
            if (!response?.financial_attributes?.trim() && !response?.attributes_no_setup) {
              this.isLoading = false;
            }
          })
      );
    } else {
      this.isLoading = false;
    }
  }

  capitalCommitmentValuesUpdated() {
    this.passEvent.emit({
      // has_balance: this.has_balance,
      title: this.title,
      // currentValue: this.currentValue,
      currentDate: this.currentDate,
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  async getDataForAttributes() {
    this.financialAttributes = this.allAttributes;

    this.isLoading = true;
    this.isLoadingBalance.set(true);

    // Create an array of promises for all async operations
    const promises = this.financialAttributes.map((attribute) => this.handleJson(attribute));
    // Wait for all promises to resolve
    const allAttributeDataPromise = await Promise.all(promises);

    if (allAttributeDataPromise.length === this.financialAttributes.length) {
      if (this.currentFormId) {
        this.getFinancialAttributeFormData();
      }
      this.getAttributeClass();
      this.isLoading = false;
      this.isLoadingBalance.set(false);
    }
  }

  handleJson(attribute): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscription.add(
        this.documentService.getFinancialAttribute().subscribe(
          (data) => {
            this.allAttributeData = data;

            if (this.findVaultForm(data, attribute?.toLowerCase()) != null) {
              let attributes = [...this.attributesList(), this.findVaultForm(data, attribute?.toLowerCase())].sort(
                (a, b) => parseInt(a?.value?.order) - parseInt(b?.value?.order)
              );

              const attributesWithApi = [];

              attributes = attributes.map((attribute) => {
                if (!!attribute?.value?.has_api_call) {
                  attributesWithApi.push({
                    ...attribute,
                    value: {
                      ...attribute?.value,
                      api_source: this.api_source,
                    },
                  });
                }
                return {
                  ...attribute,
                  value: {
                    ...attribute?.value,
                    api_source: this.api_source?.toLowerCase(),
                  },
                  getFormValues: this.getAttributeValue(attribute?.value?.vault_form_code) ?? null,
                };
              });

              const removeDuplicateAttributes = attributes.filter(
                (attribute, index, self) => index === self.findIndex((t) => t?.value?.vault_form_code === attribute?.value?.vault_form_code)
              );

              this.attributesList.set(removeDuplicateAttributes);
              resolve(this.attributesList());
              this.updateApiEmitter.emit(attributesWithApi);
              this.cd.detectChanges();
            } else {
              resolve(this.attributesList());
            }
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
      );
    });
  }

  getAttributeClass() {
    this.subscription.add(
      this.vaultService.vaultObject.subscribe(
        (state) => {
          let res = state.forms;
          if (res.length && res.findIndex((x) => x.id == this.fId) != -1) {
            this.attribute_class = res[res.findIndex((x) => x.id == this.fId)].attribute_class;
            this.attribute_sub_class = res[res.findIndex((x) => x.id == this.fId)].attribute_sub_class;
          }
        },
        (error) => {}
      )
    );
  }
  findVaultForm(json, param) {
    for (let key in json) {
      if (typeof json[key] === 'object') {
        if (json[key]?.vault_form_code?.toLowerCase() === param) {
          return { key: key, value: json[key] };
        } else {
          const result = this.findVaultForm(json[key], param);
          if (result) {
            return result;
          }
        }
      }
    }
    return null;
  }

  count = 1;
  getAttributeValue(vault_form_code: string) {
    if (!!this.financialAttributes) {
      const attribute = this.financialAttributes?.find((attribute) => attribute?.type == vault_form_code);
      if (!!attribute) return { ...JSON.parse(attribute?.value), effective_date: attribute?.effective_date, id: attribute?.id, attribute };
      if (!attribute) return null;
    } else {
      return undefined;
    }
  }

  async openFormDialog(attributeData, attribute, type, balanceData?: any) {
    const unstringData = this.balanceRes?.unstringData ?? balanceData?.unstringData ?? '';
    let existingAttributeItem = attribute;
    if (attributeData == 'has_distribution' && unstringData?.distribution_type?.toLowerCase() === 'other') {
      existingAttributeItem = JSON.parse(JSON.stringify(attribute));
      // add 'other' to existingAttributesList value inputs after distribution_type
      const enter_distribution_typeExist = (existingAttributeItem.value.inputs as any[]).find((input) => input.key == 'enter_distribution_type');
      if (!enter_distribution_typeExist) {
        (existingAttributeItem.value.inputs as any[]).splice(2, 0, {
          title: 'Enter Distribution Type',
          key: 'enter_distribution_type',
          type: 'Text Input',
        });
      }
    }
    const dialogRef = this.dialog.open(AttributesDialogComponent, {
      width: '550',
      height: 'auto',
      minHeight: attribute?.value?.inputs?.length > 3 && attribute?.value?.vault_form_code !== 'has_premium' ? '400px' : '275px',
      panelClass: 'attributes-dialog',
      data: {
        mode: type,
        title: attribute?.key,
        userId: this.userId,
        currentFormId: this.currentFormId,
        triggeredFrom: attribute?.key,
        expenseCategories: [],
        existingAttributesList: existingAttributeItem,
        attributeData: attributeData ?? {},
        getFormValues: this.getAttributeValue(attribute?.value?.vault_form_code) ?? null,
        attribute_type: 'financial',
        attributeType: EAttributesTypes.financialAttribute,
        balanceData: this.balanceRes ?? balanceData ?? '',
        attributeClasses: {
          attribute_class: this.attribute_class,
          attribute_sub_class: this.attribute_sub_class,
          income_expense_class: this.income_expense_class,
          income_expense_sub_class: this.income_expense_sub_class,
        },
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.allAttributeData = undefined;
          this.attributesList.set([]);
          this.financialAttributes = undefined;
          this.getList();
          this.balanceDataBehaviorSubject.handleBalanceData(data);
          // this.getBalance(this.userId);
        }
      })
    );
  }
  getFinancialAttributeFormData(currentFormId?: any) {
    this.subscription.add(
      this.documentService.getVaultUserFormFinancialAttribute(this.userId, this.currentFormId ?? currentFormId).subscribe((formData) => {
        this.financialAttributes = formData;
        const attributesWithApi = [];
        let attributes = [...this.attributesList()].sort((a, b) => parseInt(a?.value?.order) - parseInt(b?.value?.order));
        attributes = attributes.map((attribute) => {
          if (!!attribute?.value?.has_api_call) {
            attributesWithApi.push({
              ...attribute,
              value: {
                ...attribute?.value,
                api_source: this.api_source?.toLowerCase(),
              },
            });
          }
          return {
            ...attribute,
            value: {
              ...attribute?.value,
              api_source: this.api_source?.toLowerCase(),
            },
            getFormValues: this.getAttributeValue(attribute?.value?.vault_form_code) ?? null,
          };
        });

        const removeDuplicateAttributes = attributes.filter(
          (attribute, index, self) => index === self?.findIndex((t) => t?.value?.vault_form_code === attribute?.value?.vault_form_code)
        );

        this.attributesList.set(removeDuplicateAttributes);
        this.updateApiEmitter.emit(attributesWithApi);
        this.hasCalledApi = true;
        this.cd.detectChanges();
      })
    );
  }
  handleBalanceDataEmitter(data) {
    const attributesWithApi = [];
    this.attributesList().forEach((attribute) => {
      if (data.vault_form_code == attribute?.value?.vault_form_code) attribute.data = data;
      if (!!attribute?.value?.has_api_call)
        attributesWithApi.push({
          ...attribute,
        });
    });
    this.updateApiEmitter.emit(attributesWithApi);
  }
  balanceRes;

  getBalance(needToPassCurrntUserId, type: string) {
    this.subscription.add(
      this.documentService.gatLatestBalance(needToPassCurrntUserId, this.currentFormId, type).subscribe((res) => {
        this.balanceRes = res.data;
        this.currentValue = res?.data?.value;
        this.currentDate = res?.data?.effective_date;
        // this.attributeList = res.data;m
        this.cd.detectChanges();
      })
    );
  }
  isBalanceAttribute(attribute) {
    if (attribute?.value?.History) return true;
    return false;
  }
  handleRegisterBalanceComponentEmitter(event) {
    this.getBalance(this.userId, event);
  }
  getValueFromObjectT(obj: Record<string | number, unknown>) {
    if (Object.keys(obj).length > 1) {
      return typeof Object.values(obj)[1] == 'string' && (Object.values(obj)[1] as any)?.toLowerCase() === 'not editable'
        ? (Object.values(obj)[0] as string)?.toLowerCase()
        : undefined;
    }
    return undefined;
  }
  hasHistory(attribute: any) {
    return attribute?.value?.History && attribute?.value?.History.includes('Register');
  }

  handleStyleClassForAttributeValues(input: any, attribute: any, i) {
    if (typeof input?.type === 'string') {
      if (input?.type?.toLowerCase().includes('dollar') || input?.type?.toLowerCase().includes('Amount')) {
        return 'font-bold text-lg text-k-black';
      } else {
        return 'font-semibold text-base text-k-black';
      }
    }
    return 'font-semibold text-base text-k-black';
  }

  getAttributeItemValue(input: { title: string; key: string; type: string; default?: string }) {
    if (typeof input?.type === 'string') {
      if (input?.type?.toLowerCase().includes('dollar')) {
        return '$';
      }
      if (input?.type?.toLowerCase().includes('percentage')) {
        return '%';
      }
      if (input?.default?.toLowerCase() == 'not editable') {
        if (input?.type?.toLowerCase().includes('dollar')) {
          return '$';
        }
        if (input?.type?.toLowerCase().includes('percentage')) {
          return '%';
        }
        if (input?.type?.toLowerCase().includes('Numeric')) {
          return '-';
        }
        if (input?.type?.toLowerCase().includes('input')) {
          return '-';
        }
        return input?.type;
      }
      return '-';
    }
    return '-';
  }

  updateCountList(event) {
    this.updateCountListEventEmittted.next(event);
  }
  convertSwitchBooleanValueToString(value: boolean) {
    return value ? 'Yes' : 'No';
  }
  isHighPriorityAttribute(attribute) {
    return this.highPriorityAttributes.includes(attribute?.value?.vault_form_code?.toLowerCase());
  }
}
